<template>
  <div>
    <!--    <v-btn color="blue" dark @click="sheet = !sheet">-->
    <!--      Open v-model-->
    <!--    </v-btn>-->
    <v-bottom-sheet hide-overlay v-model="sheet">
      <v-sheet class="text-center" height="100px">
        <v-row align-content="center" style="height: 100px">
          <v-col cols="8" align-self="center">{{ message }}</v-col>
          <v-col cols="2" align-self="center">
            <v-btn color="indigo" block @click="law">Elfogadom</v-btn>
          </v-col>
          <v-col cols="2" align-self="center">
            <v-btn color="red" block @click="law">Elutasítom</v-btn>
          </v-col>
        </v-row>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  data: () => ({
    sheet: true,
    tiles: [
      { img: "keep.png", title: "Keep" },
      { img: "inbox.png", title: "Inbox" },
      { img: "hangouts.png", title: "Hangouts" },
      { img: "messenger.png", title: "Messenger" },
      { img: "google.png", title: "Google+" }
    ],
    message:
      "Ez a weboldal sütiket használ, hogy a lehető legjobb élményt nyújtsa weboldalunkon.",
    cookieName: "law_status"
  }),
  methods: {
    law() {
      this.sheet = false;
      //TODO cookie
    }
  }
};
</script>

<style scoped></style>
